import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  async createCredentialCopy(params) {
    try {
      const response = await axios.post(`certificates/credential-create/generate-excel?sampleFileId=${params.sampleFileId}`, params.request, {
        responseType: 'blob',
      })
      return response
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async readCredentialSample(params) {
    try {
      const response = await axios.get('certificates/credential_samples/getSample', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async addCredentialCopyStorage(params){
    try {
      const response = await axios.post('certificates/credentials-copy-storage', params)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  }
}
